import { react2angular } from 'react2angular';
import Hotspot from './index';

export const HotspotModule = angular
  .module('app.components.hotspot', [])
  .component('hotspot', react2angular(Hotspot))
  .name;



// WEBPACK FOOTER //
// ./src/app/admin/components/Hotspot/index.ng.js